import { classes } from 'src/utils'
import { Spinner } from '.'

type Props = {
  className?: string
}

export function Preloader(props: Props) {
  return (
    <div
      className={classes(
        'flex items-center justify-center px-4 py-4',
        props.className,
      )}
    >
      <Spinner />
    </div>
  )
}
